
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'SpanQueryExample',

  props: {
    query: {
      type: String,
      required: true,
    },
  },
})
